import httpRequest from './http-request';
import { mapAcademyResources } from './util';
import { isDev, isServer } from '@/common/utils';
import { isInWps } from '@/common/utils';
import wpsoffice from '@wps/wps_client_api/wpsoffice';

class Ksord {
  constructor() {
    // 服务端用https请求会失败，原因未明
    const protocol = process.server ? 'http:' : '';

    this.domain =
      isDev() && !isServer()
        ? '/ufapi'
        : `${protocol}//uf-resourcesearch.ksord.com`;
  }

  /**
   * 搜索学院资源（数据中心）
   */
  async getAcademyResources({
    from,
    size,
    keyword,
    sortBy = 'cool',
    order = 'desc',
    postType,
    topCate,
  } = {}) {
    let deviceId = '';
    if (isInWps()) {
      const res = await wpsoffice.getAppInfo().catch(() => null);
      deviceId = (res && res.hdid) || '';
    }
    const res = await httpRequest.query({
      url: `//learning.u.wps.cn/search/resource/academy`,
      options: {
        method: 'post',
        data: {
          device_id: deviceId,
          from,
          size,
          keyword,
          platform: 1,
          position: 'web_wps_academy_search_input_bar',
          resource_params: {
            academy_params: {
              sort_by: sortBy,
              order,
              client_type: ['pc'],
              post_type: postType,
              top_cate: topCate,
            },
          },
        },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      },
    });

    if (res && res.result === 'ok') {
      const resource = res.data.academy_resource;
      return {
        total: resource.total,
        data: mapAcademyResources(resource.resources),
        policy: res.policy,
      };
    }

    return null;
  }
}

export default new Ksord();
